import "core-js/modules/es6.promise";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.promise.finally";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import moment from 'moment';
import { mapState } from 'vuex';
import { get, isEmpty } from 'lodash';
import ApiService from '../../../services/apiService';
var defaultTableOptions = {
  sortBy: ['result.success'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: 10
};
var MAX_DELAY = 16000;
export default {
  name: 'CoreBackgroundJobsInfoDialog',
  props: {
    itemInfo: {
      type: Object,
      default: function _default() {
        return {};
      },
      required: true
    },
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      tableOptions: _objectSpread({}, defaultTableOptions),
      expanded: [],
      serverItemsLength: null,
      items: [],
      singleExpand: true,
      parentTitle: '',
      fetchRunnerTimeout: null,
      isPaused: false,
      progressBarPercent: 0,
      errorCount: 0,
      delay: 4000,
      isProcessing: false,
      isFetching: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['color'])), {}, {
    userDisplayName: function userDisplayName() {
      var _ref = this.itemInfo.userCreated || {},
          _ref$firstName = _ref.firstName,
          firstName = _ref$firstName === void 0 ? '' : _ref$firstName,
          _ref$lastName = _ref.lastName,
          lastName = _ref$lastName === void 0 ? '' : _ref$lastName;

      return "".concat(firstName, " ").concat(lastName).trim();
    },
    userCreated: function userCreated() {
      return get(this.itemInfo, 'userCreated');
    },
    isTasksTotal: function isTasksTotal() {
      return get(this.itemInfo, 'tasks');
    },
    numberOfDevices: function numberOfDevices() {
      if (this.itemInfo.type === 'deviceStatesCsvExport') {
        return this.itemInfo.executions.matchingIds;
      }

      if (this.itemInfo.type === 'virtualDevicesEdit' && get(this.itemInfo, 'executions.params.deviceTemplate')) {
        // subsctract creation task in templateSync runner
        return this.itemInfo.tasks.total - 1;
      } else {
        return this.itemInfo.tasks.total;
      }
    },
    isExportForDigitalTwins: function isExportForDigitalTwins() {
      return get(this.itemInfo, 'executions.params.type') === 'digitalTwin' || this.itemInfo.type === 'digitalTwinBulkDuplicate';
    },
    hasErrors: function hasErrors() {
      return get(this.itemInfo, 'tasks.errors');
    },
    isTitle: function isTitle() {
      return get(this.itemInfo, 'title');
    },
    isState: function isState() {
      return get(this.itemInfo, 'state');
    },
    isCreatedAt: function isCreatedAt() {
      return get(this.itemInfo, 'createdAt');
    },
    hasExecutions: function hasExecutions() {
      return !isEmpty(get(this.itemInfo, 'executions'));
    },
    tableLocalizations: function tableLocalizations() {
      return {
        headers: [{
          text: this.$i18n_t('BackgroundJobs.BackgroundJobs.table.entityId'),
          value: 'entityId',
          sortable: true
        }, {
          text: this.$i18n_t('Common.status'),
          value: 'result.success',
          sortable: true
        }, {
          text: '',
          value: 'actions',
          sortable: false
        }],
        tableFooterProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [10, 20, 50]
        }
      };
    },
    operationalStatus: function operationalStatus() {
      return [{
        text: this.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.operationalStatus.unset'),
        value: 0
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.operationalStatus.inTransit'),
        value: 1
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.operationalStatus.readyForOperation'),
        value: 2
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.operationalStatus.inOperation'),
        value: 3
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.operationalStatus.temporaryInactive'),
        value: 4
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.operationalStatus.decommissioned'),
        value: 5
      }];
    }
  }),
  watch: {
    tableOptions: {
      handler: function handler() {
        this.fetchTasks();
      },
      deep: true
    },
    itemInfo: function itemInfo() {
      var _this = this;

      this.calculateAndSetProgressBar();

      if (this.itemInfo.state !== 'in progress') {
        clearTimeout(this.fetchRunnerTimeout);
        this.fetchTasks();
      }

      var parentId = this.itemInfo.executions ? this.itemInfo.executions.parentId : null;

      if (!parentId) {
        return;
      }

      ApiService.digitalTwinGet(this, parentId).then(function (twin) {
        _this.parentTitle = twin.title;
      }).catch(function (error) {
        console.error(error);
      });
    },
    isOpen: function isOpen() {
      if (!this.isOpen || this.itemInfo.state !== 'in progress') {
        clearTimeout(this.fetchRunnerTimeout);
        return;
      }

      this.fetchRunner();
    }
  },
  mounted: function mounted() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
  methods: {
    localizeDate: function localizeDate(a) {
      if (a) {
        moment.locale(this.$store.state.app.language || window.navigator.userLanguage || window.navigator.language);
        return moment(a).format('L LT');
      }

      return '-';
    },
    getItemPerPage: function getItemPerPage(newPageSize) {
      this.tableOptions.itemsPerPage = newPageSize;
    },
    updatePagination: function updatePagination(e) {
      this.tableOptions.page = e.page;
    },
    closeJobDetails: function closeJobDetails() {
      this.items = [];
      this.progressBarPercent = 0;
      this.isProcessing = false;
      this.$emit('close');
    },
    setCurrentTablePage: function setCurrentTablePage(value) {
      this.tableOptions.page = value;
    },
    handleExpansion: function handleExpansion(item, state) {
      var itemIndex = this.expanded.indexOf(item);
      state ? this.expanded.splice(itemIndex, 1) : this.expanded.push(item);
    },
    fetchTasks: function fetchTasks() {
      var _this2 = this;

      this.isFetching = true;
      ApiService.fetchBackgroundRunnerTasksLogs(this.itemInfo.id, (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage, this.tableOptions.itemsPerPage, this.tableOptions.sortBy[0], this.tableOptions.sortDesc[0]).then(function (res) {
        res.tasks.forEach(function (task) {
          // if task was cancelled, still set the success-attribute, so the sorting works
          // (otherwise error and cancelled states are mixed)
          if (!task.result) {
            task.result = {
              success: -1
            };
          }
        });
        _this2.items = res.tasks;
        _this2.serverItemsLength = res.totalCount;
        _this2.isProcessing = _this2.itemInfo.state !== 'canceled' && _this2.progressBarPercent < 100;
      }).catch(function () {// do nothing
      }).finally(function () {
        _this2.isFetching = false;
      });
    },
    fetchRunner: function fetchRunner() {
      var _this3 = this;

      var forceRun = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var performRun = function performRun() {
        ApiService.fetchBackgroundRunner(_this3.itemInfo.id).then( /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(runner) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _this3.itemInfo = runner;

                    _this3.calculateAndSetProgressBar();

                    _this3.fetchRunner();

                  case 3:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }()).catch(function () {
          if (_this3.errorCount > 5) {
            return;
          }

          _this3.errorCount++;
          _this3.delay = Math.min(_this3.delay * 2, MAX_DELAY);
        });
      };

      if (forceRun) {
        performRun();
        return;
      }

      if (this.isPaused || !this.isOpen) {
        return;
      }

      this.fetchRunnerTimeout = setTimeout(performRun, this.delay);
    },
    triggerTaskRetry: function triggerTaskRetry(task) {
      var _this4 = this;

      ApiService.retryBackgroundRunnerTask(this.itemInfo.id, task.id).catch(function () {// do nothing
      }).finally(function () {
        _this4.progressBarPercent = 0;

        _this4.fetchRunner(true);

        _this4.fetchTasks();
      });
    },
    handleVisibilityChange: function handleVisibilityChange() {
      var visibilityState = document.visibilityState;

      if (visibilityState === 'hidden') {
        this.pauseFetchRunner();
      } else if (visibilityState === 'visible') {
        this.resumeFetchRunner();
      }
    },
    pauseFetchRunner: function pauseFetchRunner() {
      this.isPaused = true;
    },
    resumeFetchRunner: function resumeFetchRunner() {
      this.isPaused = false;
      this.fetchRunner();
    },
    calculateAndSetProgressBar: function calculateAndSetProgressBar() {
      var finished = this.itemInfo.tasks.done + this.itemInfo.tasks.errors;
      var total = this.itemInfo.tasks.total;
      this.progressBarPercent = finished / total * 100;
    },
    getStatus: function getStatus(item) {
      if (!item.result || item.result.success === -1) {
        if (this.itemInfo.type === 'deviceStatesCsvExport' && item.state === 'created') {
          return this.$i18n_t('BackgroundJobs.BackgroundJobs.createdAndWaiting');
        }

        return this.$i18n_t('BackgroundJobs.BackgroundJobs.canceled');
      }

      if (item.result && item.result.success) {
        switch (this.itemInfo.type) {
          case 'virtualDevicesCsvImport':
          case 'digitalTwinBulkDuplicate':
            return this.$i18n_t('BackgroundJobs.BackgroundJobs.successfullyImported');

          case 'virtualDevicesEdit':
            if (item.actions && item.actions.params && item.actions.params.deviceTemplate) {
              return this.$i18n_t('BackgroundJobs.BackgroundJobs.taskCreation');
            }

            return this.$i18n_t('BackgroundJobs.BackgroundJobs.successfullyEdited');

          case 'deviceStatesCsvExport':
            if (item.entityId === this.itemInfo.id) {
              // postprocessing task entityId is same as backgroundRunner id
              return this.$i18n_t('BackgroundJobs.BackgroundJobs.successfullyCombinedAndZipped');
            }

            return this.$i18n_t('BackgroundJobs.BackgroundJobs.successfullyExported');

          default:
            return 'not supported task type';
        }
      } else {
        return this.$i18n_t('BackgroundJobs.BackgroundJobs.error');
      }
    },
    constructUrl: function constructUrl(item) {
      if (get(item, 'result.data.properties.type') === 'digitalTwin' && get(item, 'result.success')) {
        return "/digitaltwin-mgmt/".concat(get(item, 'result.data.id'));
      }

      if (get(item, 'result.data.properties.type') === 'virtualDevice' && get(item, 'result.success')) {
        return "/virtual-devices/".concat(get(item, 'result.data.id'));
      }

      if (item.type === 'deviceStatesCsvExport') {
        if (get(item, 'actions.params.type') === 'virtualDevice') {
          return "/virtual-devices/".concat(item.entityId);
        } else {
          return "/digitaltwin-mgmt/".concat(item.entityId);
        }
      }

      return null;
    },
    entityUrlPrefix: function entityUrlPrefix(item) {
      if (get(item, 'result.data.properties.type') === 'digitalTwin' && get(item, 'result.success')) {
        return "".concat(this.$i18n_t('Common.twinId'), ": ");
      }

      if (get(item, 'result.data.properties.type') === 'virtualDevice' && get(item, 'result.success')) {
        return "".concat(this.$i18n_t('Common.virtualId'), ": ");
      }

      return '#';
    }
  }
};